import React, { Suspense, lazy } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import $ from "jquery";
import iziToast from "izitoast";
import "izitoast/dist/css/iziToast.min.css";
import "./styles/custom.css";

import LinkInterceptor from "./components/LinkInterceptor.jsx";
import BuilderApp from "./builder/BuilderApp.jsx";

// Route-level code splitting: each page (and its inline base64 assets) becomes
// its own chunk so the initial load stays small.
const Home = lazy(() => import("./pages/Home.jsx"));
const About = lazy(() => import("./pages/About.jsx"));
const ApiBasedSolutions = lazy(() => import("./pages/ApiBasedSolutions.jsx"));
const PackageSolutions = lazy(() => import("./pages/PackageSolutions.jsx"));
const PaymentSolutions = lazy(() => import("./pages/PaymentSolutions.jsx"));
const PhonePayments = lazy(() => import("./pages/PhonePayments.jsx"));
const VideoStreaming = lazy(() => import("./pages/VideoStreaming.jsx"));

// Expose globals the original code relied on (jQuery for DemoModal's $.ajax,
// iziToast referenced as window.iziToast in the login modals).
window.$ = window.jQuery = $;
window.iziToast = iziToast;

createRoot(document.getElementById("root")).render(
  <BrowserRouter>
    <LinkInterceptor />
    <Suspense fallback={null}>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/index.php" element={<Home />} />
        <Route path="/about_us.php" element={<About />} />
        <Route path="/api_based_solutions.php" element={<ApiBasedSolutions />} />
        <Route path="/package_solutions.php" element={<PackageSolutions />} />
        <Route path="/payment_solutions.php" element={<PaymentSolutions />} />
        <Route path="/phonesystem_with_payments.php" element={<PhonePayments />} />
        {/* Lenken finnes allerede i Footer.jsx; her er ruten den peker paa. */}
        <Route path="/video_and_event_streaming.php" element={<VideoStreaming />} />
        <Route path="/video-streaming" element={<VideoStreaming />} />
        <Route path="/builder.php" element={<BuilderApp />} />
        <Route path="*" element={<Home />} />
      </Routes>
    </Suspense>
  </BrowserRouter>
);
